import TcfmLabels from './TcfmLabels'

export default TcfmLabels
